import { ImportModule } from "app/helpers/importsHelper";
import { HOC } from "app/helpers/routerHocHelper";
import { ROUTES } from "app/helpers/routerPathHelper";
const DesktopRouteHelper = [
  {
    path: ROUTES.asianEvents,
    component: HOC.AsianEventsScreenDesktop,
  },
  {
    path: ROUTES.asianOpenBets,
    component: HOC.AsianOpenBetsScreen,
  },
  {
    path: ROUTES.asianFunding,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianFundingSkrill,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianFundingNuveiCreditCard,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianFundingNuveiInterac,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianFundingNuveiGooglePay,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianFundingApplePay,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianFundingNetellerSuccess,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianFundingNetellerError,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianFundingNetellerWithdrawSuccess,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianFundingNeteller,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianFundingNeteller,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianFundingBankwire,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianFundingAquapay,
    component: HOC.AsianFunding,
  },
  {
    path: ROUTES.asianStatement,
    component: HOC.AsianStatementScreen,
  },
  {
    path: ROUTES.asianStatement,
    component: HOC.AsianReportsScreenDesktop,
  },
  {
    path: ROUTES.asianSettings,
    component: HOC.AsianAccountScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningAboutUsLicenceInformation,
    component: HOC.AsianHelpAndLearningAboutUsLicenceInformationScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningTermsAndConditions,
    component: HOC.AsianHelpAndLearningTermsAndConditionsScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningResponsibleGaming,
    component: HOC.AsianHelpAndLearningResponsibleGamingScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningTermsAndConditionsPrivacyPolicy,
    component:
      HOC.AsianHelpAndLearningTermsAndConditionsPrivacyPolicyScreenDesktop,
  },
  {
    path: ROUTES.asianAccount,
    component: HOC.AsianAccountDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningContactAndSupportContactUs,
    component: HOC.AsianHelpAndLearningContactAndSupportContactUs,
  },
  {
    path: ROUTES.events,
    component: HOC.EventsScreenDesktop,
  },
  {
    path: ROUTES.eventsBySport, // '/events/sports/sportName or id'
    component: HOC.EventsScreenDesktop,
  },
  {
    path: ROUTES.eventsByCompetition, // '/events/competitions/competitionName or id'
    component: HOC.EventsScreenDesktop,
  },
  {
    path: ROUTES.bookmarks,
    component: HOC.EventsScreenDesktop,
  },
  {
    path: ROUTES.eventDetail,
    component: HOC.EventsScreenDesktop,
  },
  {
    path: ROUTES.favourites,
    component: HOC.EventsScreenDesktop,
  },
  {
    path: ROUTES.futures,
    component: HOC.EventsScreenDesktop,
  },
  {
    path: ROUTES.event,
    component: HOC.EventsScreenDesktop,
  },
  {
    path: ROUTES.reports,
    component: ImportModule.ReportsScreen,
  },
  {
    path: ROUTES.manageFunding,
    component: HOC.ManageFundingScreenDesktop,
  },
  {
    path: ROUTES.asianManageFunding,
    component: HOC.AsianManageFundingScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearning,
    component: HOC.HelpAndLearningScreensDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearning,
    component: HOC.AsianHelpAndLearningScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningWelcomeHelpAndLearning,
    component: HOC.HelpAndLearningWelcomeHelpAndLearningScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningWelcomeHelpAndLearning,
    component: HOC.AsianHelpAndLearningWelcomeHelpAndLearningScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningGettingStartedFundingYourAccount,
    component: HOC.HelpAndLearningGettingStartedFundingYourAccountScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningGettingStartedFundingYourAccount,
    component:
      HOC.AsianHelpAndLearningGettingStartedFundingYourAccountScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningGettingStartedPlacingABet,
    component: HOC.HelpAndLearningGettingStartedPlacingABetScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningGettingStartedPlacingABet,
    component: HOC.AsianHelpAndLearningGettingStartedPlacingABetScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningGettingStartedOurOdds,
    component: HOC.HelpAndLearningGettingStartedOurOddsScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningGettingStartedOurOdds,
    component: HOC.AsianHelpAndLearningGettingStartedOurOddsScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningGettingStartedQuickLinks,
    component: HOC.HelpAndLearningGettingStartedQuickLinksScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningGettingStartedQuickLinks,
    component: HOC.AsianHelpAndLearningGettingStartedQuickLinksScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningRulesAndRegulationsSportsRules,
    component: HOC.HelpAndLearningRulesAndRegulationsSportsRulesScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningRulesAndRegulationsSportsRules,
    component: HOC.AsianHelpAndLearningRulesAndRegulationsSportsRules,
  },
  {
    path: ROUTES.helpAndLearningRulesAndRegulationsMarketRules,
    component: HOC.HelpAndLearningRulesAndRegulationsMarketRulesScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningRulesAndRegulationsMarketRules,
    component: HOC.AsianHelpAndLearningRulesAndRegulationsMarketRules,
  },
  {
    path: ROUTES.helpAndLearningRulesAndRegulationsCodeOfConduct,
    component: HOC.HelpAndLearningRulesAndRegulationsCodeOfConductScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningRulesAndRegulationsCodeOfConduct,
    component: HOC.AsianHelpAndLearningRulesAndRegulationsCodeOfConduct,
  },
  {
    path: ROUTES.helpAndLearningContactAndSupportContactUs,
    component: HOC.HelpAndLearningContactAndSupportContactUsScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningContactAndSupportContactUs,
    component: HOC.AsianHelpAndLearningContactAndSupportContactUs,
  },
  {
    path: ROUTES.helpAndLearningFaqsMyAccount,
    component: HOC.HelpAndLearningFaqsMyAccountScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningFaqsMyAccount,
    component: HOC.AsianHelpAndLearningFaqsMyAccountScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningFaqsFunding,
    component: HOC.HelpAndLearningFaqsFundingScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningFaqsFunding,
    component: HOC.AsianHelpAndLearningFaqsFundingScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningAboutUsLicenceInformation,
    component: HOC.HelpAndLearningAboutUsLicenceInformationScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningAboutUsLicenceInformation,
    component: HOC.AsianHelpAndLearningAboutUsLicenceInformationScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningFaqsBetting,
    component: HOC.HelpAndLearningFaqsBettingScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningFaqsBetting,
    component: HOC.AsianHelpAndLearningFaqsBettingScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningAboutUsLicenceInformation,
    component: HOC.HelpAndLearningAboutUsLicenceInformationScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningAboutUsLicenceInformation,
    component: HOC.AsianHelpAndLearningAboutUsLicenceInformationScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningResponsibleGaming,
    component: HOC.HelpAndLearningResponsibleGamingScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningSelfExclusion,
    component: HOC.HelpAndLearningSelfExclusionScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningResponsibleGaming,
    component: HOC.AsianHelpAndLearningResponsibleGamingScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningSelfExclusion,
    component: HOC.AsianHelpAndLearningSelfExclusionScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningTermsAndConditions,
    component: HOC.HelpAndLearningTermsAndConditionsScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningTermsAndConditions,
    component: HOC.AsianHelpAndLearningTermsAndConditionsScreenDesktop,
  },
  {
    path: ROUTES.helpAndLearningTermsAndConditionsPrivacyPolicy,
    component: HOC.HelpAndLearningTermsAndConditionsPrivacyPolicyScreenDesktop,
  },
  {
    path: ROUTES.asianHelpAndLearningTermsAndConditionsPrivacyPolicy,
    component:
      HOC.AsianHelpAndLearningTermsAndConditionsPrivacyPolicyScreenDesktop,
  },
  {
    path: ROUTES.profile,
    component: HOC.ProfileScreenDesktop,
  },
  {
    path: ROUTES.asianProfile,
    component: HOC.AsianProfileScreenDesktop,
  },
  {
    path: ROUTES.asianControls,
    component: HOC.AsianControlsScreenDesktop,
  },
  {
    path: ROUTES.account,
    component: HOC.AccountScreenDesktop,
  },
  {
    path: ROUTES.asianAccountVerification,
    component: HOC.AsianAccountVerificationScreenDesktop,
  },
  {
    path: ROUTES.accountVerification,
    component: HOC.AccountVerificationScreenDesktop,
  },
  {
    path: ROUTES.accountcontrols,
    component: HOC.AccountControlsScreenDesktop,
  },
];
export default DesktopRouteHelper;
